// XXX: SwitchTransitionを使っている関係で、コンポーネントがunmountされるときもコンポーネントのレンダリングが走る。
//      このタイミングではコンポーネントに渡されるrouterの情報は次のページ用のrouterになっているため、普通にやるとエラーになる。
//      これを防ぐため、初回のレンダリング時のrouter情報をstateに保持する実装にしている。

import type { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'
import type { ZodSchema } from 'zod'

// TODO: valueのtypeが変わってエラーが起きないよう注意が必要。その際に自動でクリアするようなロジックが欲しいが可能か？
export const useStateWithLocalStorage = <T>(
  key: string,
  initialValue: T,
  schema?: ZodSchema<T>,
  options?: {
    forceInitialize: boolean
  },
): [T, Dispatch<SetStateAction<T>>, () => void] => {
  let restoredValue: unknown
  try {
    const x = localStorage.getItem(key)
    restoredValue = x === null ? undefined : JSON.parse(x)
  } catch (_e) {
    // TODO: 握り潰す形で良いか？
  }

  // validationに通らなかったらデフォルトの値は使わない
  if (schema !== undefined) {
    const result = schema.safeParse(restoredValue)
    if (!result.success) {
      restoredValue = undefined
      localStorage.removeItem(key)
    }
  }

  // オプション池があればデフォルト値は使わない
  if (options?.forceInitialize === true) {
    restoredValue = undefined
  }

  const [value, setValue] = useState<T>((restoredValue ?? initialValue) as T)
  const setValueAndSetItem: Dispatch<SetStateAction<T>> = (setStateActionOrValue) => {
    let newValue
    if (setStateActionOrValue instanceof Function) {
      setValue((oldValue) => {
        const newValue = setStateActionOrValue(oldValue)
        localStorage.setItem(key, JSON.stringify(newValue))
        return newValue
      })
    } else {
      newValue = setStateActionOrValue
      setValue(newValue)
      try {
        localStorage.setItem(key, JSON.stringify(newValue))
      } catch (e: unknown) {
        // eslint-disable-next-line no-console
        console.warn(e)
      }
    }
  }

  const resetValueAndStorage = () => {
    setValue(initialValue)
    localStorage.setItem(key, JSON.stringify(initialValue))
  }

  return [value, setValueAndSetItem, resetValueAndStorage]
}
